import { observable, computed } from 'mobx';
import type { Moment } from 'moment';
import moment from 'moment';

export type CandidateResponseArgs = {
  id?: number;
  start_time: string;
  end_time: string;
  description?: string;
};

export type CandidateArgs = {
  id?: number;
  title?: string;
  start: Moment;
  end: Moment;
  description?: string;
};

export const candidateTitle = '候補日（ダブルクリックで削除）';
export const candidateMobileTitle = '候補日（ロングタップで削除）';
export const travelTimeTitle = '移動時間';

export const convertCandidateResponseToArgs = (response: CandidateResponseArgs, isMobile?: boolean) => {
  return {
    id: response.id,
    title: isMobile ? candidateMobileTitle : candidateTitle,
    start: moment(response.start_time),
    end: moment(response.end_time),
    description: response.description
  };
};

export default class Candidate {
  @observable id?: number;
  @observable title: string;
  @observable start: Moment;
  @observable end: Moment;
  @observable description?: string;

  constructor(args: CandidateArgs) {
    this.id = args.id;
    this.title = args.title || candidateTitle;
    this.start = args.start;
    this.end = args.end;
    this.description = args.description;
  }

  dateText(isSlash: boolean) {
    const withYear = this.start.year() !== moment().year();
    if (isSlash) {
      return this.start.format(withYear ? 'YYYY/MM/DD(ddd)' : 'MM/DD(ddd)');
    }
    return this.start.format(withYear ? 'YYYY年MM月DD日(ddd)' : 'MM月DD日(ddd)');
  }

  @computed
  get duration() {
    return this.end.diff(this.start, 'minutes');
  }

  @computed
  get timeText() {
    let text = this.start.year() !== moment().year() ? this.start.format('YYYY年') : '';
    text += this.start.format('MM月DD日(ddd) HH:mm - ') + this.end.format('HH:mm');
    return text;
  }
}
